import styled from "styled-components";
import { TextButton } from "../../Button/TextButton";

export const Backdrop = styled("div")`
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: #000;
  opacity: 0.3;
  z-index: 999;
  top: 0;
`;

export const Dialog = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  max-width: 900px;
  width: 100%;
  height: 600px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 999999;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.4);
`;

export const MainContent = styled("div").attrs((props) => ({
    className: props.className,
}))`
  display: grid;
  grid-template-columns: 60% 40%;
  flex: 1;

  &.full-width {
    grid-template-columns: 100%;
  }
`;

export const Header = styled("div").attrs((props) => ({
    className: props.className,
}))`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 55px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  padding: 0px 24px 0px 24px;

  &.no-padding-left {
    padding-left: 0;
  }
`;

export const Footer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 55px;
  border-top: 1px solid rgba(0, 0, 0, 0.09);
`;

export const Title = styled("div")`
  font-size: 16px;
  font-family: Manrope;
  font-weight: 500;
`;

export const CloseButton = styled("div")`
  cursor: pointer;
  padding: 5px;
  &:hover {
    background-color: #eee;
  }
`;

interface TrainingOptionProps {
  selected?: boolean;
}

export const TrainingOption = styled(TextButton)`
  font-size: 13px;
  padding: 0px;
  border-bottom: ${(props: TrainingOptionProps) =>
        props.selected ? "1px solid #e5aa43" : "none"};
  border-radius: 0px;
  color: ${(props: TrainingOptionProps) =>
        props.selected ? "#000000" : "#6d727885"};
`;

export const TrainingContainer = styled("div")`
  background: #e4e4e4;
  box-shadow: 2px -1px 10px 0 rgba(187, 187, 187, 0.5);
  border: solid 1px #e4e4e4;
  padding: 1.5px 0 0.5px;
  border-radius: 4px;
`;

export const TrainingHeaderText = styled.div`
  display: flex;
  width: 65%;
  justify-content: space-between;
  font-size: 13px;
`;

export const TrainingVideoContainer = styled.div`
  max-width: 490px;
  height: 285px;
  border: 1px solid rgba(0, 0, 0, 0.09);
  margin: 0px 0px 16px 23px;

  video {
    max-height: 100%;
    width: 100%;
  }
`;

export const TrainingDescription = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 13px;
  width: 90%;
  margin-left: 23px;
`;

export const LoadingIndicator = styled("div")`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const LoadingIndicatorBackdrop = styled("div")`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #fff;
  opacity: 0.5;
  z-index: 9999;
`;

export const LoadingIndicatorText = styled("div")`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
`;

export const SelectAll = styled.div`
  display: flex;
  align-items: center;
  width: 77px;
  font-size: 13px;
  justify-content: space-between;
  font-weight: bold;
`;

export const ThumbnailContainer = styled("div").attrs((props) => ({
    className: props.className,
}))`
  &.selected {
    img {
      border: 1px solid #8c8c8c;
    }
  }
`;

export const OutputContainer = styled("div")`
  border-radius: 4px;
  height: 490px;
  overflow: auto;
`;

export const OutputContent = styled("div").attrs((props) => ({
    className: props.className,
}))`
  display: grid;
  grid-template-columns: 160px 160px;
  grid-column-gap: 11px;
  grid-row-gap: 22px;
  padding: 16px;
  padding-bottom: 22px;

  &.full-width {
    grid-template-columns: 200px 200px 200px 200px;
  }

  @media only screen and (max-width: 768px) {
    grid-template-columns: 160px;
    justify-content: center;
  }
`;

export const OutputTile = styled("div").attrs((props) => ({
    className: props.className,
}))`
  position: relative;
  width: 160px;
  height: auto;

  &.full-width {
    width: 200px;
  }
`;

export const OutputThumbnail = styled("img")`
  width: 100%;
  height: 87px;
`;

export const OutputCheckbox = styled("input")`
  position: absolute;
  top: 15px;
  left: 0;
  appearance: none;
  height: 16px;
  width: 16px;
  border: solid 1px #c4c4c4;
  border-radius: 1px;
  background: white;

  &:checked {
    &:before {
      content: "✓";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      font-size: 15px;
      font-weight: bold;
    }
  }
`;

export const OutputCheckboxSelectAll = styled(OutputCheckbox)`
  border: solid 1px #8c8c8c;

  &:checked {
    border: 1px solid black;

    &:before {
      content: "";
      display: block;
      height: 8px;
      width: 8px;
      background: black;
      position: absolute;
      top: 0;
    }
  }
`;

export const ProgressScreenContainer = styled("div")`
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: #fff;
  opacity: 1;
  z-index: 9999999;
  top: 0;
`;

export const ProgressBarContainer = styled("div")`
  width: 400px;
  height: 400px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  background-color: #fff;
  opacity: 1;
  z-index: 9999999;
`;

export const ProgressBarTrack = styled("div")`
  width: 400px;
  height: 15px;
  padding: 3px;
  position: relative;
  border: 1px solid #ccc;
  text-align: left;
`;

interface ProgressBarProgressProps {
  percentComplete: number;
}

export const ProgressBarProgress = styled("div")`
  width: ${(props: ProgressBarProgressProps) => props.percentComplete}%;
  height: 9px;
  display: inline-block;
  background-color: #1ce180;
  position: relative;
  left: 0;
`;
/*
    transition: width 0.3s;
    transition-timing-function: ease;
 */

export const ProgressBarCaption = styled("div")`
  width: 400px;
  text-align: center;
  position: relative;
`;
